import React from 'react';
import NotFound from '../features/notFound';

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
